import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { connectionQuery } from '../../../helpers.class';
import { IGqlBaseOptions } from '../../../interfaces/base.interfaces';
import { safeResolve } from 'src/app/shared/modules/graphql/rxjs';
import { addCertificationAgencyCommentMutation, certificationAgencyCommentConnectionQuery } from './certification-agency-comment.operations';
import {
  IApiAddCertificationAgencyCommentInput,
  IApiCertificationAgencyComment,
  IApiCertificationAgencyCommentConnection,
  IApiCertificationAgencyCommentFilter
} from '../../../types/types';

@Injectable()
export class GqlCertificationAgencyCommentService {
  public constructor(
    private apollo: Apollo
  ) { }

  public getCertificationAgencyComments(filters: IApiCertificationAgencyCommentFilter[], options: IGqlBaseOptions): Observable<IApiCertificationAgencyCommentConnection> {
    return this.apollo.query(connectionQuery(certificationAgencyCommentConnectionQuery, filters, options)).pipe(
      safeResolve(true)
    );
  }

  public addCertificationAgencyComment(input: IApiAddCertificationAgencyCommentInput): Observable<IApiCertificationAgencyComment> {
    return this.apollo.mutate({
      mutation: addCertificationAgencyCommentMutation,
      variables: { input }
    }).pipe(
      safeResolve(true)
    );
  }
}
